export default __webpack_public_path__ + "static/mobile_section2_background-676b40bc95f67ee798572d369a19c41c.png";